<template>
  <div class="invoice-history-order">
    <fixed-header title="查看订单"></fixed-header>
    <div class="invoice-history-order__main scroll-touch">
      <div v-for="(item, index) in orderList" :key="index" class="invoice-history-order__main-item">
        <div class="invoice-history-order__main-info">
          <span class="invoice-history-order__main-info-time">{{ item.orderSn }}</span>
          <span class="invoice-history-order__main-info-amount">¥{{ item.payMoney }}</span>
        </div>
        <div class="invoice-history-order__main-img scroll-touch">
          <invoice-img :goods-img-list="item.imgUrl"></invoice-img>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import InvoiceImg from 'components/invoice/img';
import * as invoiceApis from 'apis/invoice';

export default {
  name: 'index',
  components: {
    FixedHeader, InvoiceImg,
  },
  data() {
    const {
      invoiceApplySn,
    } = this.$route.query;
    const nowApplySn = invoiceApplySn || '';
    return {
      nowApplySn,
      orderList: [],
    };
  },
  mounted() {
    this.getInvoiceOrderList();
  },
  methods: {
    async getInvoiceOrderList() {
      try {
        const data = await invoiceApis.getInvoiceOrderList(this.nowApplySn);
        if (data) {
          this.orderList = data;
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`获取发票订单失败:${message}`);
      }
    },
  },
};
</script>

<style lang="scss">

.invoice-history-order {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;

    &-item {
      margin: 20px 24px 0 24px;
      height: 220px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
    }

    &-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 62px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      span {
        font-size: 26px;
        color: #0D0D0D;
      }

      &-time {
        margin-left: 20px;
        width: 561px;
      }

      &-amount {
        flex: 1;
        color: #FF5F00 !important;
      }

    }

    &-img {
      margin: 27px 20px;
    }

  }
}


</style>
